<template>
    <div class="post post-facebook post-linkedin" :class="{'response-comment' : responseComment}">
        <div class="detail-event-header" :class="{'no-border' :  (post && Object.keys(post).length && !post.commentary) || isLoading}">
            <AvatarComponent v-if="currentPage" :typeNetwork="currentPage.network" :urlPicture="currentPage.avatar"></AvatarComponent>
            
            <div class="info">
                <div class="namePage" @click="scrollToOriginalComment" v-if="currentPage">
                    {{currentPage.name}}
                </div>
                <div class="typeEvent">
                    <p html>{{ dateFormatPost(event.date*1000) }}</p>
                    <template v-if="event.data && event.data.generatedActivity">
                        <p v-if="event.type == 'comment'" class="show-post"><a :href="`https://www.linkedin.com/feed/update/${event.data.sourcePost}?commentUrn=${encodeURIComponent(event.data.generatedActivity)}`" target="_blank">Voir</a></p>
                        <p v-else class="show-post"><a :href="`https://www.linkedin.com/feed/update/${event.data.sourcePost}`" target="_blank">Voir</a></p>
                    </template>
                </div>
            </div>

          
            <div class="selectActionEvent">
                <SelectComponent :id="event._id" :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"/>
            </div>
        </div>
        <div class="scrollable">
            <template v-if="post == false" >
                <div class="container-none-post">
                  <div class="none-post">
                    <p>Post non disponible</p>
                  </div>
                </div>
            </template>
            <template v-else-if="isLoading || !post || !Object.keys(post).length">
                <div class="container-content-post loading-content">
                    <div class="content-post">
                        <div class="content">                        
                           
                            <div class="picture">
                                <!-- <img :src="attachments.media.image.src"> -->
                            </div>
                        </div>
                        <div class="post-footer">

                            <div class="top">
                                <p>0 commentaires • 0 republication</p>
                            </div>
                            <div class="bottom">
                                                    
                                <div class="like">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z"></path>
                                    </svg>
                                    J'aime
                                </div>

                                <div class="comments">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z"></path>
                                    </svg>
                                    Commenter
                                </div>
        
                                <div class="share">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z"></path>
                                    </svg>
                                    Republier
                                </div>
                                <div class="send">
                                <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z"></path>
                                    </svg>
                                    Envoyer
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div class="container-content-comments loading-content">

                        <div class="container-comment" v-for="index in 3" :key="index">                     
                            <div class="comment">                 
                                <div class="picture-user">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC">             
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <p class="name-user">www</p>
                                        <p class="text">{{ 'w'.repeat(5+Math.random()*10) }}</p>
                                    </div>
                                    <div class="info-content">
                                        <!-- <div class="date">wwwwwwwww</div> -->
                                        <div class="action">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                </div>
            </template>
            <template v-else-if="post && Object.keys(post).length">
                <div class="container-content-post">
                    <div class="content-post">
                        <div class="content">
                        
                            <div class="text" v-if="post.commentary || (event.type == 'mention' && post.text && post.text.text)"><pre v-html="messagePostFormat(event.type == 'mention' && post.text && post.text.text ? post.text.text : post.commentary)"></pre></div>

                            <a class="link" v-if="post.content && post.content.article" :href="post.content.article.source" target="_blank">
                                <div class="banner-link" v-if="post.content.article.thumbnail" >
                                    <img :src="post.content.article.thumbnail.downloadUrl">
                                </div>
                                <div class="footer-link">
                                    <p class="footer-link-domaine">
                                        {{ getHostname(post.content.article.source)}}
                                    </p>
                                    <p class="footer-link-title">
                                        {{ post.content.article.title}}
                                    </p>
                                    <p class="footer-link-description">
                                        {{ post.content.article.description }}
                                    </p>
                                </div>
                            </a>

                            <template v-if="post.content && post.content.media && post.content.media.image">
                                <!-- image unique -->
                                <template v-if="post.content.media.image.downloadUrl">
                                    <div v-if="post.content.media.id.includes('urn:li:image:')" class="picture">
                                        <img :src="post.content.media.image.downloadUrl">
                                    </div>
                                </template>
                            </template>

                           
                            <template v-if="post.content && post.content.multiImage">
                                <div :class="'post-medias media'+ Math.min(post.content.multiImage.length,4)">
                                    <div 
                                        v-for="(media,i) in post.content.multiImage.slice(0,4)" 
                                        class="media" 
                                        :key="i"
                                    >
                                        <div class="count" v-if="i == 3 && post.content.multiImage.length > 4">+{{ Math.min(post.content.multiImage.length,20) - 3}}</div>
                                        <img :src="media.downloadUrl" alt="">
                                    </div>
                                </div>
                            </template>

                            <template v-if="post.content && post.content.media && post.content.media.video">
                                <!-- video unique -->
                                <template v-if="post.content.media.video.downloadUrl">
                                    <div v-if="post.content.media.id.includes('urn:li:video:')" class="video">
                                        <video controls :src="post.content.media.video.downloadUrl"> </video>
                                      
                                       
                                    </div>
                                </template>
                            </template>

                            <template v-if="post.content && post.content.media && post.content.media.document">
                                <!-- pdf -->
                                <template v-if="post.content.media.document.downloadUrl">
                                    <div class="pdf-viewer">                                        
                                        <div class="navigation-bar">
                                            <span class="title">{{ post.content.media.title }}</span><span>•</span>{{ pdfPageNumber }} pages
                                        </div>
                                        <pdf  @numpages="(n) => pdfPageNumber = n" :src="post.content.media.document.downloadUrl" :page="pdfPage"></pdf>
                                    
                                        <div class="previous btn-nav" v-if="pdfPage > 1" @click="()=> pdfPage--"><i class="fa-solid fa-chevron-left"></i></div>
                                        <div class="next btn-nav" v-if="pdfPage < pdfPageNumber" @click="()=> pdfPage++"><i class="fa-solid fa-chevron-right"></i></div>
                                    </div>
                                </template>
                            </template>
                            
                        </div>
                        
                        <div class="post-footer">

                            <div class="top">
                                
                                <div class="reactions">
                                    <template v-if="post && post.reactions && post.reactions.reactionSummaries">
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.MAYBE">
                                            <img src="../../../assets/img/reporting_icons/linkedin-curious.png" alt="MAYBE">
                                            <span class="text">{{ post.reactions.reactionSummaries.MAYBE.count }}</span>
                                        </div>
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.PRAISE">
                                            <img src="../../../assets/img/reporting_icons/linkedin-celebrate.png" alt="PRAISE"> 
                                            <span class="text">{{ post.reactions.reactionSummaries.PRAISE.count }}</span>
                                        </div>
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.LIKE">
                                            <img src="../../../assets/img/reporting_icons/linkedin-like.png" alt="LIKE"> 
                                            <span class="text">{{ post.reactions.reactionSummaries.LIKE.count }}</span>
                                        </div>
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.EMPATHY">
                                            <img src="../../../assets/img/reporting_icons/linkedin-love.png" alt="EMPATHY"> 
                                            <span class="text">{{ post.reactions.reactionSummaries.EMPATHY.count }}</span>
                                        </div>
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.INTEREST">
                                            <img src="../../../assets/img/reporting_icons/linkedin-insightful.png" alt="INTEREST"> 
                                            <span class="text">{{ post.reactions.reactionSummaries.INTEREST.count }}</span>
                                        </div>
                                        <div class="reaction" v-if="post.reactions.reactionSummaries.APPRECIATION">
                                            <img src="../../../assets/img/reporting_icons/linkedin-support.png" alt="APPRECIATION"> 
                                            <span class="text">{{ post.reactions.reactionSummaries.APPRECIATION.count }}</span>
                                        </div>
                                        <!-- <div class="sum">{{$t('dash.reporting.total_reactions') + ' ' + numberSpacing(data[indextr].post_reactions[0].sum)}}</div> -->
                                    </template>
                                </div>

                                <p v-if="post && post.reactions && post.reactions.commentSummary && post.reactions.commentSummary.count">{{ post.reactions.reactionSummaries.LIKE ? post.reactions.reactionSummaries.LIKE.count : 0 }} {{ post.reactions.reactionSummaries.LIKE && post.reactions.reactionSummaries.LIKE.count > 1 ? 'likes' : 'like' }} • {{ post.reactions.commentSummary.count }} {{ post.reactions.commentSummary.count > 1 ? 'commentaires' : 'commentaire' }}</p>
                                <p v-else-if="post && post.stats && post.stats.elements && post.stats.elements.length">{{ post.stats.elements[0].totalShareStatistics.likeCount }} {{ post.stats.elements[0].totalShareStatistics.likeCount > 1 ? 'likes' : 'like' }} • {{ post.stats.elements[0].totalShareStatistics.commentCount }} {{ post.stats.elements[0].totalShareStatistics.commentCount > 1 ? 'commentaires' : 'commentaire' }} • {{ post.stats.elements[0].totalShareStatistics.shareCount }} {{ post.stats.elements[0].totalShareStatistics.shareCount > 1 ? 'republications' : 'republication' }}</p>
                                <!-- <p v-if="post && post.stats && post.stats.elements && post.stats.elements.length">{{ post.stats.elements[0].totalShareStatistics.likeCount }} {{ post.stats.elements[0].totalShareStatistics.likeCount > 1 ? 'like' : 'likes' }} • {{ post.stats.elements[0].totalShareStatistics.commentCount }} {{ post.stats.elements[0].totalShareStatistics.commentCount > 1 ? 'commentaire' : 'commentaires' }} • {{ post.stats.elements[0].totalShareStatistics.shareCount }} {{ post.stats.elements[0].totalShareStatistics.shareCount > 1 ? 'republication' : 'republications' }}</p> -->
                                <!-- <p v-else>0 commentaires • 0 republication</p> -->
                            </div>
                            <div class="bottom">
                                                    
                                <div class="like" @click="toggleLikePost(post.id)" :class="[{liked: isLiked}]">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z"></path>
                                    </svg>
                                    J'aime
                                </div>

                                <div class="comments" @click="autoFocus = true">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z"></path>
                                    </svg>
                                    Commenter
                                </div>
        
                                <div class="share" @click="!shared ? reshare() : null" :class="[{shared}]">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z"></path>
                                    </svg>
                                    Republier
                                </div>
                                <div class="send">
                                <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                        <path d="M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z"></path>
                                    </svg>
                                    Envoyer
                                </div>
                            </div>
                        
                        </div>

                    </div>
                </div>
                <div class="container-content-comments" ref="comments">
                    <template v-if="post.comments && post.comments.data && post.comments.data.length">
                        <div class="container-comment" v-for="(comment,indexComment) in post.comments.data" :key="comment.id">
                            
                            <div class="comment" :class="{'has-response' : comment.comments && comment.comments.data && comment.comments.data.length, 'hidden':comment.is_hidden, 'originalComment': getConvertGeneratedActivity == comment['$URN']}" :ref="event.data.generatedActivity.replace('(activity', '(urn:li:activity') == comment['$URN'] ? 'originalComment' : null">
                                <div class="picture-user">
                                    <img :src="comment.user && comment.user.logoV2 ? comment.user.logoV2 : 'img/avatar.jpg'">
                                    <div class="lineStart"></div>
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <p class="name-user">{{ comment.user.name }}</p>
                                        <p class="text">{{ comment.message.text }}</p>
                                        <p class="deleted-notice" v-if="comment.deleted">Commentaire supprimé</p>
                                        <div class="media"></div>

                                        <ContextMenu :options="getOptionComment(comment.id, comment) " :id="comment.id" v-on:clickOption="clickOptionComment">
                                            <div class="btn-more"></div>
                                        </ContextMenu>
                                        
                                    </div>
                                    <div class="info-content">
                                        <div class="date">{{ dateFormat(comment.created.time) }}</div>
                                        <div class="action">
                                            <div class="reaction" :class="{'have-liked' : comment.user_likes}" @click="toggleLikeComment(comment.id)">J'aime {{ comment.like_count ? ` (${comment.like_count})` : ''}}</div>
                                            <div class="answer" @click="startResponseComment(comment.id)">Répondre</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="comment.comments && comment.comments.data && comment.comments.data.length" >
                                <div v-for="(subComment,indexSubComment) in comment.comments.data" :key="subComment.id" :class="{'end': comment.comment_count == indexSubComment+1 || (!comment.comments.data[indexSubComment+1]),'hidden':subComment.is_hidden, 'originalComment': getConvertGeneratedActivity == subComment['$URN']}" class="comment response" :ref="event.data.generatedActivity.replace('(activity', '(urn:li:activity') == subComment['$URN'] ? 'originalComment' : null">
                                    <div class="jonction-line line-continuous"></div>
                                    <div class="picture-user"> 
                                        <img :src="subComment.user && subComment.user.logoV2 ? subComment.user.logoV2 : 'img/avatar.jpg'">
                                    </div>
                                    <div class="container-content">
                                        <div class="content">
                                            <p class="name-user">{{ subComment.user.name }}</p>
                                            <p class="text">{{ subComment.message.text }}</p>
                                            <p class="deleted-notice" v-if="subComment.deleted">Commentaire supprimé</p>
                                            <div class="media"></div>

                                            <ContextMenu :options="getOptionComment(subComment.id, subComment) " :id="subComment.id" v-on:clickOption="clickOptionComment">
                                                <div class="btn-more"></div>
                                            </ContextMenu>
                                        </div>
                                        <div class="info-content">
                                            <div class="date">{{ dateFormat(subComment.created.time) }}</div>
                                            <div class="action">
                                                <div class="reaction" :class="{'have-liked' : subComment.user_likes}" @click="toggleLikeComment(subComment.id)">J'aime</div>
                                                <div class="answer" @click="startResponseComment(comment.id+','+subComment.id)">Répondre</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <p class="no-comment">Aucun commentaire</p>
                    </template>
                </div>
            </template>
         
        </div>
       
        <FormSendMessage v-on:onSubmitMessage="sendComment" :activeMedia="false" :setAutofocus="autoFocus" @autoFocused="autoFocus = false"></FormSendMessage>
     
        <div class="container-response-comment" v-if="responseComment">
            <p>Répondre à <span>{{getCommentById(responseComment.split(',').pop()) ? getCommentById(responseComment.split(',').pop()).user.name : ''}}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopResponseComment"></i>
        </div>
    </div>
</template>

<script>
    import mixinModeration from '../../mixins/Moderation.vue'
    import mixinPosts from '../../mixins/Posts.vue'
    import ContextMenu from '../contextMenu/contextMenuInit.vue'
    import FormSendMessage from './FormSendMessage'
    import AvatarComponent from '../utils/avatar.vue'
    import SelectComponent from '../utils/select.vue'
    import Queuer from '../../../utils/Queuer'
    import { Carousel, Slide } from 'vue-carousel';
    import pdf from 'pdfvuer'

    export default {
        name: 'component-post-linkedin',

        components: {
            FormSendMessage,
            ContextMenu,
            AvatarComponent,
            SelectComponent,
            Carousel,
            Slide,
            pdf
        },

        mixins: [mixinModeration, mixinPosts],

        props: {
            page: Object,
            post: Object,
            event: Object,
            isLoading : {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                responseComment: false,
                saveUrlPictureUser : {},
                displayloaderNextComment : false,
                idParentOriginalComment : null,
                activeScrollToOriginalComment : true,
                currentPage: null,
                pdfPage: 1,
                pdfPageNumber: 0,
                autoFocus: false,
                shared: false
            }
        },

        mounted () {
            this.getDetailAllComment()
            if (this.activeScrollToOriginalComment) {
                this.activeScrollToOriginalComment = false
                this.scrollToOriginalComment();
            }
        },

        updated() {
            if (this.activeScrollToOriginalComment) {
                this.activeScrollToOriginalComment = false
                this.scrollToOriginalComment();
            }
               
        },

        computed: {
            getConvertGeneratedActivity() {
                return this.event ? this.event.data.generatedActivity.replace('(activity', '(urn:li:activity').replace('(ugcPost', '(urn:li:ugcPost') : null
            },

            isLiked() {
                return !!(this.post && this.post.user_likes && (typeof this.post.user_likes !== 'object' || this.post.user_likes.status != 404))
            },
        },

        methods: {

            reshare() {

                let bots = JSON.parse(localStorage.bots)
                let bot = bots.find(b => b.page.id == this.page.id)

                if(!bot) {
                    console.log('no bot found')
                    return false
                }

                this.shared = true

                let body = {
                    bot: bot.id,
                    service: bot.service,
                    data: {
                        title: '',
                        url: '',
                        scheduled_date: null,
                        typePost: 'standard',
                        is_reshare: true,
                        reshare_message: '',
                        news_title: this.post.commentary,
                        news_url: '',
                        reshare_post_id: this.post.id
                    },
                    last: true,
                    nbPosts: 1,
                    scheduled: false
                }

                this.newPost(body).then(res => {
                    console.log('res',res)
                    const { success, error } = res.body

                    if(!success && error){
                        console.log('error reshare', error)
                        this.shared = false
                        return
                    }

                    let reqId = this.event.data.generatedActivity
                    let moreData
                    if(this.event.data.decoratedSourcePost && this.event.data.decoratedSourcePost.entity)
                        moreData = {post: this.event.data.decoratedSourcePost.entity}
                    else if(this.event.data.decoratedGeneratedActivity && this.event.data.decoratedGeneratedActivity.comment)
                        moreData = {post: this.event.data.decoratedGeneratedActivity.comment.object}

                    this.$emit('updateEventMissingInfos', this.event._id, this.page, reqId, null, moreData)
                })
            },

            changeStatus(status){
                this.$emit('changeStatus', status)
            },

            // Un commentaire supprimé peut être le sujet de son propre event dans l'inbox
            // (une autre notification, indépendante de celle affichée ici) : si on le trouve,
            // on le marque supprimé aussi plutôt que de le laisser trainer en attente.
            async markCommentEventDeleted(objectId) {
                try {
                    let res = await this.getInboxEvent(this.page.id, objectId)
                    if (res && res.body && res.body.event && res.body.event._id)
                        await this.postInboxEvent(res.body.event._id, this.page, { status: 4 })
                } catch (e) {
                    console.error('markCommentEventDeleted failed', e)
                }
            },

            getFormatNumber(number) {
                const absNumber = Math.abs(number);
                const fixed = function(value){
                    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
                }

                if (absNumber >= 1e9) {
                    return fixed(number / 1e9) + ' MD';
                } else if (absNumber >= 1e6) {
                    return fixed(number / 1e6) + ' M';
                } else if (absNumber >= 1e3) {
                    return fixed(number / 1e3) + ' K';
                } else {
                    return number.toString();
                }
                
            },

            dateFormat(dateComment) {
                if (typeof dateComment !== "object") {
                    dateComment = new Date(dateComment)
                }

                let date = new Date()
                const diffInMilliseconds = Math.abs(date - dateComment);
                const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
                const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
                const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
                const diffInWeeks = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 7));
                const diffInYears = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 365));

                if (diffInYears > 0) {
                    return diffInYears + (diffInYears === 1 ? ' an' : ' ans');
                } else if (diffInWeeks > 0) {
                    return diffInWeeks + 'sem';
                } else if (diffInDays > 0) {
                    return diffInDays + 'j';
                } else if (diffInHours > 0) {
                    return diffInHours + 'h';
                } else {
                    return diffInMinutes + 'min';
                }
            },

            messagePostFormat(text) {
                // Ajouter un espace devant les https/http si aucun espace n'est présent juste avant
                // Ajouter un espace devant les www si aucun // ou espace n'est présent juste avant
                text = text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2") // eslint-disable-line


                //URLs starting with http://, https://, or ftp://
                let replacePattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim; // eslint-disable-line
                text = text.replace(replacePattern, '<a href="$1" target="_blank">$1</a>');

                //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
                replacePattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim; // eslint-disable-line
                text = text.replace(replacePattern, '$1<a href="http://$2" target="_blank">$2</a>');

                //Change email addresses to mailto:: links.
                replacePattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim; // eslint-disable-line
                text = text.replace(replacePattern, '<a href="mailto:$1">$1</a>'); // eslint-disable-line
                
                //Mention starting @[mentionName](mentionId) - Organization
                replacePattern = /@\[([^\]]+)\]\(urn:li:organization:([^)]+)\)/gim; // eslint-disable-line
                text = text.replace(replacePattern, '<a href="https://linkedin.com/company/$2" target="_blank">$1</a>');

                //Mention starting @[mentionName](mentionId) - User
                replacePattern = /@\[([^\]]+)\]\(urn:li:person:([^)]+)\)/gim; // eslint-disable-line
                text = text.replace(replacePattern, '<a href="https://www.linkedin.com/search/results/all/?keywords=$1" target="_blank">$1</a>');
                
                //Hashtag starting {hashtag|\#|value} or {hashtag|#|value}
                replacePattern = /\{hashtag\|\\?#\|(.*?)\}/gim // eslint-disable-line
                text = text.replace(replacePattern, '<a href="https://www.linkedin.com/search/results/all/?keywords=%23$1" target="_blank">#$1</a>');

                return text.trim();
            },

            getLastUrlInText(text) {
                try {
                    return text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2").match(/\b(?:https?:\/\/(?:www\.)?|www\.)\S+/gi).slice(-1)[0] // eslint-disable-line
                }catch (error) {
                    return false
                }
                
            },

            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },

            dateFormatPost(dateMessage) {
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            have_liked_comment(nodeId){

                try {
                    this.post.comment.likes.data.find(liker => liker.id == this.page.network_id) 
                } catch (error) {
                    return false
                }   
            },

            startResponseComment(commentId) {
                this.responseComment = commentId;
            },
            
            scrollToOriginalComment() {
                if(this.$refs.originalComment && this.$refs.originalComment.length) {
                    const element = this.$refs.originalComment[0];
                    if (element) {
                        this.$refs.comments.scrollIntoView({ behavior: "smooth"});
                    }
                }
            },

            stopResponseComment() {
                this.responseComment = false
            },

            getCommentById(commentId,returnNode = false) {
                if (this.post.comments && this.post.comments.data) {
                    for (const comment of this.post.comments.data) {
                        if (comment.id == commentId) {
                            return returnNode ? this.post.comments : comment;
                        } else if (comment.comments && comment.comments.data) {
                            for (const subComment of comment.comments.data) {
                                if (subComment.id == commentId) {
                                    return returnNode ? comment.comments : subComment;
                                }else if (subComment.comments && subComment.comments.data) {
                                    for (const subsubComment of subComment.comments.data) {
                                        if (subsubComment.id == commentId) {
                                            return returnNode ? subComment.comments : subsubComment;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            },
            
            async toggleLikeComment(nodeId) {
                let comment = this.getCommentById(nodeId) 
                console.log(comment)
                if (comment.user_likes) return

                const toggleFlagLike = async (comment)=>{
                    if (!comment.user_likes) {
                        await this.$set(comment,'user_likes',true)
                        await this.$set(comment, 'like_count', comment.like_count ? comment.like_count + 1 : 1)
                    }
                    //comment.user_likes = comment.user_likes ? !comment.user_likes : true
                    return comment.user_likes 
                }

                const flagLike = await toggleFlagLike(comment)
                if (flagLike !== undefined) {
                    let res = await this.likeNode(this.page, comment && comment['$URN'] ? comment['$URN'] : nodeId)
       
                    const { success, error } = res.body
                 
                    if (!success || success !== true) {
                        toggleFlagLike(comment)
                        return false
                    }
                    else {
                        let reqId = this.event.data.generatedActivity
                        let moreData
                        if(this.event.data.decoratedSourcePost && this.event.data.decoratedSourcePost.entity)
                            moreData = {post: this.event.data.decoratedSourcePost.entity}
                        else if(this.event.data.decoratedGeneratedActivity && this.event.data.decoratedGeneratedActivity.comment)
                            moreData = {post: this.event.data.decoratedGeneratedActivity.comment.object}

                        this.$emit('updateEventMissingInfos', this.event._id, this.page, reqId, null, moreData)
                    }

                    return true
                    
                }
            },

            async toggleLikePost(nodeId) {
                if (this.isLiked) return

                const previousUserLikes = this.post.user_likes
                const previousLikeCount = this.post.like_count

                await this.$set(this.post, 'user_likes', true)
                await this.$set(this.post, 'like_count', this.post.stats && this.post.stats.elements && this.post.stats.elements.length && this.post.stats.elements[0].totalShareStatistics && this.post.stats.elements[0].totalShareStatistics.likeCount ? this.post.stats.elements[0].totalShareStatistics.likeCount + 1 : 1)

                let res = await this.likeNode(this.page, nodeId)

                const { success, error } = res.body

                if (!success || success !== true) {
                    await this.$set(this.post, 'user_likes', previousUserLikes)
                    await this.$set(this.post, 'like_count', previousLikeCount)
                    return false
                }
                else {
                    this.postInboxEvent(this.event._id, this.page, { postLiked: true })

                    let reqId = this.event.data.generatedActivity
                    let moreData
                    if(this.event.data.decoratedSourcePost && this.event.data.decoratedSourcePost.entity)
                        moreData = {post: this.event.data.decoratedSourcePost.entity}
                    else if(this.event.data.decoratedGeneratedActivity && this.event.data.decoratedGeneratedActivity.comment)
                        moreData = {post: this.event.data.decoratedGeneratedActivity.comment.object}

                    this.$emit('updateEventMissingInfos', this.event._id, this.page, reqId, null, moreData)
                }

                return true
            },
    
            async sendComment(formData,filesUrl = []) {


                if (this.post && formData.get('message')) {

                    if (this.responseComment) {
                        console.log(this.responseComment,this.responseComment.split(',')[0])
                        const commentTarget = this.getCommentById(this.responseComment.split(',')[0])
                        console.log("commentTarget",commentTarget)
                        if (commentTarget) {
                            
                            if (!commentTarget.comments || !commentTarget.comments.data) {
                      
                                await this.$set(commentTarget,'comments' ,{
                                    data : [

                                    ],
                                    paging : {
                                        "cursors":{
                                            "before":"",
                                            "after":""}
                                    },
                                    summary : {
                                        "order":"ranked",
                                        "total_count":0,
                                        "can_comment":true
                                    }
                                })
                                commentTarget.comment_count = 0
                            }

                            commentTarget.comment_count++

                            await this.$set(commentTarget.comments.data, commentTarget.comments.data.length, {
                                can_hide: false,
                                comment_count: 0,
                                created_time: new Date().toISOString(),
                                created: {time: new Date().toISOString()},
                                from: {"name":this.page.name, email:"", id: this.page.network_id},
                                id: "",
                                is_hidden: false,
                                like_count: 0,
                                message: {text: formData.get('message')},
                                user_likes: false,
                                user : {
                                    "name":this.page.name,
                                    "logoV2":this.page.avatar
                                }
                            });
                            
                            console.log('commentTarget', commentTarget)
                            // let res = await this.addComment(this.page, 'urn:li:comment:'+commentTarget.id, formData.get('message'), this.post.id)
                            let res = await this.addComment(this.page, commentTarget['$URN'], formData.get('message'))
                            const { success, comment } = res.body

                            if (!success || success !== true) {
                                commentTarget.comments.data.pop()
                                return
                            }
                            else {
                                let reqId = this.event.data.generatedActivity
                                let moreData
                                if(this.event.data.decoratedSourcePost && this.event.data.decoratedSourcePost.entity)
                                    moreData = {post: this.event.data.decoratedSourcePost.entity}
                                else if(this.event.data.decoratedGeneratedActivity && this.event.data.decoratedGeneratedActivity.comment)
                                    moreData = {post: this.event.data.decoratedGeneratedActivity.comment.object}

                                this.$emit('updateEventMissingInfos', this.page.id, reqId, null, moreData)
                            }
                                
                        }
                                        
                        this.stopResponseComment()
                    }else{
                        if (!this.post.comments || !this.post.comments.data) {
                            await this.$set(this.post,'comments' ,{
                                data : [
                                    
                                ],
                                summary : {
                                    "order":"ranked",
                                    "total_count":0,
                                    "can_comment":true
                                }
                            })
                        }
                        
                        await this.$set(this.post.comments.data, this.post.comments.data.length, {
                            can_hide: false,
                            comment_count: 0,
                            created_time: new Date().toISOString(),
                            created: {time: new Date().toISOString()},
                            from: {"name":this.page.name, email:"", id:this.page.network_id},
                            id: "",
                            is_hidden: false,
                            like_count: 0,
                            message: {text: formData.get('message')},
                            user_likes: false,
                            user : {
                                "name":this.page.name,
                                "logoV2":this.page.avatar
                            }
                        })

                        // let res = await this.addComment(this.page, this.event.type == 'mention' ? this.post.activity : this.post.id, formData.get('message'))
                        let res = await this.addComment(this.page, this.post.id, formData.get('message'))
                        const { success, comment } = res.body

                        if (!success || success !== true) {
                            this.post.comments.data.pop()
                            return
                        } 
                        else {
                            let reqId = this.event.data.generatedActivity
                            let moreData
                            if(this.event.data.decoratedSourcePost && this.event.data.decoratedSourcePost.entity)
                                moreData = {post: this.event.data.decoratedSourcePost.entity}
                            else if(this.event.data.decoratedGeneratedActivity && this.event.data.decoratedGeneratedActivity.comment)
                                moreData = {post: this.event.data.decoratedGeneratedActivity.comment.object}

                            this.$emit('updateEventMissingInfos', this.event._id, this.page, reqId, null, moreData)
                        }
                    }    
                    
                }

            },

            async clickOptionComment(id, nameOption) {
      
            
                switch (nameOption) {
                    case 'deleteComment': {
                        //save parent
                        let deletedComment = this.getCommentById(id)
                        let isOriginalComment = deletedComment && deletedComment['$URN'] == this.getConvertGeneratedActivity

                        let nodeComment = this.getCommentById(id,true)

                        if (nodeComment) {
                            let saveNodeComment = Object.assign({}, nodeComment);
                            nodeComment.data = nodeComment.data.filter((comment) => comment.id !== id)

                            let res = await this.deleteNodelinkedin(this.page, this.event.data.sourcePost, id)

                            let { success, error } = res.body;

                            if (!success || success !== true) {
                                nodeComment = saveNodeComment
                            }
                            else if (isOriginalComment) {
                                this.$emit('deleteComment', this.event._id)
                            }
                            else if (deletedComment && deletedComment['$URN']) {
                                this.markCommentEventDeleted(`comment-${deletedComment['$URN']}`)
                            }
                        }

                        break;
                    }
                        
                    case 'hideComment': {
                        let commentHide = this.getCommentById(id)
                        commentHide.is_hidden = false
                        let resHideComment = await this.hideNode(this.page, this.event.object_id, true)  //true, incoherence du server (ça devrait etre true) 
                        let { success: hideSuccess, error: hideError } = resHideComment.body;
                      
                        if (!hideSuccess || hideSuccess !== true) {
                            commentHide.is_hidden = false
                        }
                        break;
                    }

                    case 'showComment': {
                        let commentShow = this.getCommentById(id)
                        commentShow.is_hidden = true
                
                        let resShowComment = await this.hideNode(this.page, this.event.object_id, false) //false, incoherence du server (ça devrait etre false) 
                        let { success: showSuccess, error: showError } = resShowComment.body;
              
                        if (!showSuccess || showSuccess !== true) {
                            commentShow.is_hidden = false
                        }
                        break;
                    }

                    case 'evaluateComment': {
                    
                        break;
                    }
              
                }
            },
     
            getOptionComment(idComment, comment) {
                if (!comment) {
                    comment = this.getCommentById(idComment)
                }

                let options = [{label: this.$t('dash.button.delete'), name : 'deleteComment'}]
                //,{label: this.$t('dash.inbox.filter.evaluate'), name : 'evaluateComment'}

                if (comment.can_hide && comment.from.id !== this.page.network_id) {

                    if (comment.is_hidden) {
                        options = [{label: this.$t('dash.inbox.state.unhide'), name : 'showComment'},...options]
                    }else{
                        options = [{label: this.$t('dash.pages.group.hide'), name : 'hideComment'},...options]
                    }
      
                }
                return options



            },

            async getOriginalComment() {
                if(this.post && this.post.comments && this.post.comments.data && this.post.comments.data.length && this.post.comments.data[0].parentComment)
                    this.idParentOriginalComment = this.post.comments.data[0].parentComment
            },

            async getDetailAllComment(indexStart = 0, indexEnd = null) {

                // if (this.post && this.post.comments &&  this.post.comments.data) {
                //     if(!indexEnd)
                //         indexEnd = this.post.comments.data.length
                  
                //     let queueComment = new Queuer({
                //         data: JSON.parse(JSON.stringify(this.post.comments.data)).slice(indexStart,indexEnd),
                //         task: async (comment) => {
                            
                //             let ind = this.post.comments.data.findIndex(c => c.id == comment.id)

                //             //verifier si le liens de l'image existe déja pour eviter une requette
                //             if (!([comment.from.id] in this.saveUrlPictureUser)) {
                //                 let resComment = await this.getEventMissingInfosFromRS(this.page.id, comment.from.id, 'comment')
                //                 if(resComment && resComment.body && resComment.body.user) {
                //                     this.$set(this.post.comments.data[ind], 'user', resComment.body.user)
                //                     this.saveUrlPictureUser[comment.from.id] = (resComment.body.user.picture && resComment.body.user.picture.data && !resComment.body.user.picture.data.is_silhouette && resComment.body.user.picture.data.url) ? resComment.body.user.picture.data.url : false               
                //                 }
                //             }
                //             if (this.post.comments.data[ind].comments && this.post.comments.data[ind].comments.data && this.post.comments.data[ind].comments.data.length) {

                //                 let queueSubComment = new Queuer({
                            
                //                     data: JSON.parse(JSON.stringify(this.post.comments.data[ind].comments.data)),
                //                     task: async (subComment) => {
                //                         let iSubComment = this.post.comments.data[ind].comments.data.findIndex(c => c.id == subComment.id)
                                       
                //                         //verifier si le liens de l'image existe déja pour eviter une requette
                //                         if (!([subComment.from.id] in this.saveUrlPictureUser)) {
                //                             let resComment = await this.getEventMissingInfosFromRS(this.page.id, subComment.from.id, 'comment')
                //                             if(resComment && resComment.body && resComment.body.user) {
                //                                 this.$set(this.post.comments.data[ind].comments.data[iSubComment], 'user', resComment.body.user)
                //                                 this.saveUrlPictureUser[subComment.from.id] = (resComment.body.user.picture && resComment.body.user.picture.data && !resComment.body.user.picture.data.is_silhouette && resComment.body.user.picture.data.url) ? resComment.body.user.picture.data.url : false
                //                             }
                //                         }
                //                         queueSubComment.unlock()
                //                     }
                //                 })
                //                 setTimeout(queueSubComment.init(), 500)
                //             }
                //             queueComment.unlock()         
                //         }
                //     })
                //     setTimeout(queueComment.init(), 500)
                // }
            },

            async getNextComment() {
     
                if (this.post.comments.paging.next) {
                    this.displayloaderNextComment = true
                    let request = await this.$http.get(this.post.comments.paging.next, {}).then(res => res, err => err);
                  
                    if (request.body && request.body.data) {
                        if (request.body.paging) {
                            this.post.comments.paging = request.body.paging
                        }else{
                            this.post.comments.paging = false
                        }
                        let newArray = (this.post.comments.data).concat(request.body.data)
                        this.post.comments.data = newArray
                        this.getDetailAllComment(newArray.length-request.body.data.length-1)
                    }
                   
                    this.displayloaderNextComment = false
                }
            },

            async getNextResponseComment(indexComment) {
            
                if (this.post.comments && this.post.comments.data && this.post.comments.data[indexComment]  && this.post.comments.data[indexComment].comments && this.post.comments.data[indexComment].comments.paging && this.post.comments.data[indexComment].comments.paging.next) {
                    
                    this.$set(this.post.comments.data[indexComment], 'displayloaderNextComment', true)
                    let request = await this.$http.get(this.post.comments.data[indexComment].comments.paging.next, {}).then(res => res, err => err);
                  
                    if (request.body && request.body.data) {
                        if (request.body.paging) this.post.comments.data[indexComment].comments.paging = request.body.paging

                        if (this.idParentOriginalComment == this.post.comments.data[indexComment].id) {
                            request.body.data = request.body.data.filter(c=> c.id !== this.event.data.changes.value.comment_id) //retire le commentaire de l'evenement car deja inserer
                        }

                        let newArray = (this.post.comments.data[indexComment].comments.data).concat(request.body.data)
                        this.post.comments.data[indexComment].comments.data = newArray
                        this.getDetailAllComment(indexComment,indexComment+1)
                    }
                    this.post.comments.data[indexComment].displayloaderNextComment = false
                }
            },

        },

        watch: {
            async post(newPost, lastPost) {
                if (this.post && Object.keys(this.post).length) {
                    // this.isLoading = true
                    await this.getOriginalComment()
                    await this.getDetailAllComment()
                    if (!lastPost || newPost.id !== lastPost.id) {
                        this.activeScrollToOriginalComment = true
                    }
                    // this.isLoading = false
                } 
                
                this.currentPage = this.page
                if(this.event.type == 'mention' && this.event.detail && this.event.detail.user) {
                    this.currentPage = {
                        avatar: this.event.detail.user.logoV2 ? this.event.detail.user.logoV2 : null,
                        name: this.event.detail.user.name,
                        network: 'linkedin',
                        network_id: this.event.detail.user.id
                    }
                }
               
            }
        },
    }
</script>
